import React, { useState } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  DialogActions,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

function AddScriptModal({
  onClose,
  categoryName,
  setCategoryName,
  scriptText,
  setScriptText,
  onSave,
}) {
  return (
    <>
      <Typography variant="h6" sx={{ pb: 1 }}>
        Додавання скрипту
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
        <Typography>Назва категорії</Typography>
        <TextField
          fullWidth
          size="small"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
        />
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
        <Typography>Текст скрипту</Typography>
        <TextField
          multiline
          rows={4}
          fullWidth
          value={scriptText}
          onChange={(e) => setScriptText(e.target.value)}
        />
      </Box>

      <DialogActions sx={{ justifyContent: "left" }}>
        <Button
          sx={{ textTransform: "none", borderRadius: "15px" }}
          variant="contained"
          onClick={onSave} // вызываем родительский onSave
        >
          <Typography variant="subtitle2">Зберігти</Typography>
        </Button>
        <Button
          sx={{ textTransform: "none", borderRadius: "15px" }}
          onClick={onClose}
        >
          Закрити
        </Button>
      </DialogActions>
    </>
  );
}

export default AddScriptModal;
